export function pickupAddressValidate(pickup_address){
    var result = true;

    result = validateClientName(pickup_address.client_name);
    result = validateId(pickup_address.id);
    result = validateAddress(pickup_address.address);
    result = validateContact(pickup_address.contact);
    result = validateIsDefault(pickup_address.is_default);
    result = validateAuthorized(pickup_address.authorized);

    return result;
}

function validateClientName(name) {
    if(typeof name !== 'string' || name.trim() === '') return false;
    return true;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateAddress(address) {   
    if(typeof address.country !== 'string' || address.country.trim() === '') return false;
    if(typeof address.country_code !== 'string' || address.country_code.trim() === '') return false;
    if(typeof address.state !== 'string' || address.state.trim() === '') return false;
    if(typeof address.state_code !== 'string' || address.state_code.trim() === '') return false;
    if(typeof address.municipality !== 'string' || address.municipality.trim() === '') return false;
    if(typeof address.neighborhood !== 'string' || address.neighborhood.trim() === '') return false;
    if(typeof address.street !== 'string' || address.street.trim() === '') return false;
    if(typeof address.external_number !== 'string' || address.external_number.trim() === '') return false;
    if(typeof address.zipcode !== 'string' || address.zipcode.trim() === '') return false;
    if(typeof address.group !== 'string' || address.group.trim() === '') return false;

    return true;
}

function validateContact(contact) {
    if(typeof contact.name !== 'string' || contact.name.trim() === '') return false;
    if(typeof contact.email !== 'string' || contact.email.trim() === '') return false;
    if(typeof contact.phone !== 'string' || contact.phone.trim() === '') return false;

    return true;
}

function validateIsDefault(is_default){
    if(typeof is_default !== 'boolean') return false;
    else return true;
}

function validateAuthorized(authorized){
    if(typeof authorized !== 'boolean') return false;
    else return true;
}